import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { withAuth } from '../../auth'
import { acceptTandC } from '../../actions'
import App from './'
import { useMutation } from '@apollo/react-hooks'
import { SAVE_USER } from '../../queries/user'

import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'
import Button from '@mui/material/Button'
import { styled } from '@mui/material/styles'

import { Document, Page } from 'react-pdf/dist/entry.webpack'
import 'react-pdf/dist/Page/AnnotationLayer.css'
import pdf from './ARUP_VDA_Tool_Acceptable_Use_and_Privacy_Policy.pdf'

const PREFIX = 'AcceptTerms'
const classes = {
  block: `${PREFIX}-block`,
}
const Block = styled('div')(({ theme }) => ({
  [`&.${classes.block} > *`]: {
    margin: theme.spacing(1),
  },
}))

const AcceptTerms = props => {
  const { userInfo, auth } = props
  const dispatch = useDispatch()
  const [saveUser] = useMutation(SAVE_USER)

  const accept = async () => {
    const userInput = {
      email: userInfo.email,
    }
    dispatch(acceptTandC())
    await saveUser({ variables: { input: userInput } })
  }

  const reset = async () => {
    auth.logout(window.location.origin)
  }

  const [numPages, setNumPages] = useState(null)
  const [pageNumber, setPageNumber] = useState(1)
  const [acceptEnabled, setAcceptEnabled] = useState(false)

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages)
    setPageNumber(1)
  }

  function changePage(offset) {
    setPageNumber(prevPageNumber => prevPageNumber + offset)
    if (pageNumber + offset === numPages) {
      setAcceptEnabled(true)
    }
  }

  function previousPage() {
    changePage(-1)
  }

  function nextPage() {
    changePage(1)
  }

  return (
    <>
      <Container maxWidth="sm">
        <Block className={classes.block}>
          <Typography variant="h4" gutterBottom>
            Terms & Conditions
          </Typography>
          <Typography variant="body1" gutterBottom>
            {/* eslint-disable-next-line react/no-unescaped-entities */}
            Please read the document below then click "I ACCEPT"
          </Typography>
          <Button onClick={accept} color="primary" disabled={!acceptEnabled}>
            I accept
          </Button>
          <Button onClick={reset} color="primary">
            {/* eslint-disable-next-line react/no-unescaped-entities */}I don't
            accept
          </Button>
        </Block>
        <Block className={classes.block}>
          <Typography variant="body1" gutterBottom>
            Page {pageNumber || (numPages ? 1 : '--')} of {numPages || '--'}
          </Typography>
          <Button
            variant="contained"
            color="primary"
            disabled={pageNumber <= 1}
            onClick={previousPage}
          >
            Previous
          </Button>
          <Button
            variant="contained"
            color="primary"
            disabled={pageNumber >= numPages}
            onClick={nextPage}
          >
            Next
          </Button>
        </Block>
        <Block className={classes.block}>
          <Document file={pdf} onLoadSuccess={onDocumentLoadSuccess}>
            <Page pageNumber={pageNumber} />
          </Document>
        </Block>
      </Container>
    </>
  )
}

const AcceptTermsWall = props => {
  const { userInfo, auth } = props
  const { acceptedTandC } = useSelector(state => state)

  return (
    <>
      {acceptedTandC ? (
        <App userInfo={userInfo} />
      ) : (
        <AcceptTerms userInfo={userInfo} auth={auth} />
      )}
    </>
  )
}

export default withAuth(AcceptTermsWall)
